import { jsx as x } from "react/jsx-runtime";
import { useAbstractedLink as e } from "../../contexts/RouterAbstraction/context.js";
function k({
  url: f,
  children: r,
  target: o,
  className: a,
  onClick: i,
  title: d,
  linkRef: m,
  replace: L,
  rel: n = "",
  disablePointerEvents: p,
  ...t
}) {
  const b = e();
  return (f || "").indexOf("://") === -1 ? /* @__PURE__ */ x(
    b,
    {
      to: f,
      href: f,
      title: d,
      target: o,
      className: a,
      onClick: i,
      ref: m,
      rel: n,
      ...t,
      replace: L,
      "aria-disabled": p,
      children: r
    }
  ) : /* @__PURE__ */ x(
    "a",
    {
      title: d,
      href: f,
      rel: n,
      target: o,
      onClick: i,
      ref: m,
      "aria-disabled": p,
      ...t,
      className: a,
      children: r
    }
  );
}
export {
  k as SmartLink
};
